window.KicksownSizeData = {
  "version": "2026-11-02-size-chart-audit-complete",
  "charts": {
    "sneaker-mystery-box": {
      "label": "Sneaker Mystery Box Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US W": "5",
          "EU": "35.5",
          "CM": "22",
          "US M": "3.5",
          "UK": "2.5"
        },
        {
          "US W": "5.5",
          "EU": "36",
          "CM": "22.5",
          "US M": "4",
          "UK": "3"
        },
        {
          "US W": "6",
          "EU": "36.5",
          "CM": "23",
          "US M": "4.5",
          "UK": "3.5"
        },
        {
          "US W": "6.5",
          "EU": "37.5",
          "CM": "23.5",
          "US M": "5",
          "UK": "4"
        },
        {
          "US W": "7",
          "EU": "38",
          "CM": "23.5",
          "US M": "5.5",
          "UK": "4.5"
        },
        {
          "US W": "7.5",
          "EU": "38.5",
          "CM": "24",
          "US M": "6",
          "UK": "5"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25",
          "US W": "9"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41",
          "CM": "25.5",
          "US W": "9.5"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "26",
          "US W": "10"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42.5",
          "CM": "26.5",
          "US W": "10.5"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "43",
          "CM": "27",
          "US W": "11"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "27",
          "US W": "11.5"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "27.5",
          "US W": "12"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "45",
          "CM": "28",
          "US W": "12.5"
        },
        {
          "US M": "11.5",
          "UK": "10.5",
          "EU": "45.5",
          "CM": "28.5",
          "US W": "13"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46",
          "CM": "29",
          "US W": "13.5"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "47",
          "CM": "29.5",
          "US W": "14"
        },
        {
          "US M": "13",
          "UK": "12",
          "EU": "47.5",
          "CM": "30",
          "US W": "14.5"
        },
        {
          "US M": "13.5",
          "UK": "12.5",
          "EU": "48",
          "CM": "30.5",
          "US W": "15"
        },
        {
          "US M": "14",
          "UK": "13",
          "EU": "48.5",
          "CM": "30.5",
          "US W": "15.5"
        },
        {
          "US M": "14.5",
          "UK": "13.5",
          "EU": "49",
          "CM": "31",
          "US W": "16"
        },
        {
          "US M": "15",
          "UK": "14",
          "EU": "49.5",
          "CM": "31.5",
          "US W": "16.5"
        },
        {
          "US M": "16",
          "UK": "15",
          "EU": "50.5",
          "CM": "32.5",
          "US W": "17.5"
        },
        {
          "US M": "17",
          "UK": "16",
          "EU": "51.5",
          "CM": "33.5",
          "US W": "18.5"
        }
      ]
    },
    "lining": {
      "label": "Li-Ning Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "2.5",
          "US W": "4",
          "UK": "1.5",
          "EU": "33.5",
          "CM": "20.5"
        },
        {
          "US M": "3",
          "US W": "4.5",
          "UK": "2",
          "EU": "34",
          "CM": "21"
        },
        {
          "US M": "3.5",
          "US W": "5",
          "UK": "2.5",
          "EU": "35",
          "CM": "21.5"
        },
        {
          "US M": "4",
          "US W": "5.5",
          "UK": "3",
          "EU": "35.5",
          "CM": "21.5"
        },
        {
          "US M": "4.5",
          "US W": "6",
          "UK": "3.5",
          "EU": "36",
          "CM": "22"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "UK": "4",
          "EU": "37",
          "CM": "22.5"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "UK": "5",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "5.5",
          "EU": "39",
          "CM": "24"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "39.5",
          "CM": "24.5"
        },
        {
          "US M": "7.5",
          "US W": "9",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "UK": "7.5",
          "EU": "41.5",
          "CM": "26"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "UK": "8",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "UK": "8.5",
          "EU": "43",
          "CM": "27"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "UK": "9",
          "EU": "43.5",
          "CM": "27.5"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "UK": "9.5",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "UK": "10",
          "EU": "45",
          "CM": "28.5"
        },
        {
          "US M": "11.5",
          "US W": "13",
          "UK": "10.5",
          "EU": "45.5",
          "CM": "29"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "UK": "11",
          "EU": "46",
          "CM": "29.5"
        },
        {
          "US M": "12.5",
          "US W": "14",
          "UK": "11.5",
          "EU": "47",
          "CM": "30"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "UK": "12",
          "EU": "47.5",
          "CM": "30.5"
        },
        {
          "US M": "13.5",
          "US W": "15",
          "UK": "12.5",
          "EU": "48",
          "CM": "31"
        },
        {
          "US M": "14",
          "US W": "15.5",
          "UK": "13",
          "EU": "49",
          "CM": "31.5"
        },
        {
          "US M": "14.5",
          "US W": "16",
          "UK": "13.5",
          "EU": "49.5",
          "CM": "32"
        },
        {
          "US M": "15",
          "US W": "16.5",
          "UK": "14",
          "EU": "50",
          "CM": "32.5"
        },
        {
          "US M": "15.5",
          "US W": "17",
          "UK": "14.5",
          "EU": "51",
          "CM": "33"
        },
        {
          "US M": "16",
          "US W": "17.5",
          "UK": "15",
          "EU": "51.5",
          "CM": "33.5"
        },
        {
          "US M": "16.5",
          "US W": "18",
          "UK": "15.5",
          "EU": "52",
          "CM": "34"
        }
      ]
    },
    "lining-kids": {
      "label": "Li-Ning Kids Size Guide",
      "systems": [
        "US Kids",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US Kids": "11C",
          "UK": "10.5",
          "EU": "28",
          "CM": "17.5"
        },
        {
          "US Kids": "11TC",
          "UK": "11",
          "EU": "29",
          "CM": "18"
        },
        {
          "US Kids": "12TC",
          "UK": "12",
          "EU": "30",
          "CM": "18.5"
        },
        {
          "US Kids": "0.5",
          "UK": "13",
          "EU": "31",
          "CM": "19.5"
        },
        {
          "US Kids": "1.5",
          "UK": "1",
          "EU": "32",
          "CM": "20"
        },
        {
          "US Kids": "2",
          "UK": "1.5",
          "EU": "33",
          "CM": "20.5"
        },
        {
          "US Kids": "3",
          "UK": "2.5",
          "EU": "34",
          "CM": "21.5"
        },
        {
          "US Kids": "3.5",
          "UK": "3",
          "EU": "35",
          "CM": "22"
        },
        {
          "US Kids": "4.5",
          "UK": "4",
          "EU": "36",
          "CM": "23"
        },
        {
          "US Kids": "5",
          "UK": "4.5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US Kids": "6",
          "UK": "5.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US Kids": "6.5",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US Kids": "7.5",
          "UK": "7",
          "EU": "40",
          "CM": "25"
        },
        {
          "US Kids": "8",
          "UK": "7.5",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US Kids": "9",
          "UK": "8.5",
          "EU": "42",
          "CM": "26"
        }
      ]
    },
    "anta": {
      "label": "ANTA Size Guide",
      "systems": ["US M", "UK", "EU", "CHN", "CM", "IN"],
      "rows": [
        {"US M":"6.5","UK":"6","EU":"39","CHN":"245","CM":"24.2","IN":"9.5"},
        {"US M":"7","UK":"6.5","EU":"40","CHN":"250","CM":"24.7","IN":"9.7"},
        {"US M":"7.5","UK":"6.5","EU":"40.5","CHN":"250","CM":"25.1","IN":"9.9"},
        {"US M":"8","UK":"7","EU":"41","CHN":"255","CM":"25.5","IN":"10"},
        {"US M":"8.5","UK":"7.5","EU":"42","CHN":"260","CM":"25.9","IN":"10.2"},
        {"US M":"9","UK":"8","EU":"42.5","CHN":"265","CM":"26.3","IN":"10.4"},
        {"US M":"9.5","UK":"8.5","EU":"43","CHN":"270","CM":"26.8","IN":"10.5"},
        {"US M":"10","UK":"9","EU":"44","CHN":"270","CM":"27.2","IN":"10.7"},
        {"US M":"10.5","UK":"9.5","EU":"44.5","CHN":"275","CM":"27.6","IN":"10.8"},
        {"US M":"11","UK":"10","EU":"45","CHN":"280","CM":"28.0","IN":"11"},
        {"US M":"11.5","UK":"10.5","EU":"45.5","CHN":"285","CM":"28.4","IN":"11.2"},
        {"US M":"12","UK":"11","EU":"46","CHN":"290","CM":"28.9","IN":"11.3"},
        {"US M":"12.5","UK":"11.5","EU":"47","CHN":"295","CM":"29.3","IN":"11.5"},
        {"US M":"13","UK":"12","EU":"47.5","CHN":"300","CM":"29.7","IN":"11.7"},
        {"US M":"13.5","UK":"12.5","EU":"48","CHN":"305","CM":"29.9","IN":"11.8"},
        {"US M":"14","UK":"13","EU":"48.5","CHN":"310","CM":"30.5","IN":"12"},
        {"US M":"15","UK":"14","EU":"49.5","CHN":"315","CM":"31.4","IN":"12.3"},
        {"US M":"16","UK":"15","EU":"50.5","CHN":"325","CM":"32.3","IN":"12.7"},
        {"US M":"17","UK":"16","EU":"51.5","CHN":"335","CM":"33.5","IN":"13.2"}
      ],
      "tables": [
        {
          "label": "ANTA Men's Shoes",
          "systems": ["US M", "EU", "UK", "CHN", "CM", "IN"],
          "rows": [
            {"US M":"6.5","EU":"39","UK":"6","CHN":"245","CM":"24.2","IN":"9.5"}, {"US M":"7","EU":"40","UK":"6.5","CHN":"250","CM":"24.7","IN":"9.7"}, {"US M":"7.5","EU":"40.5","UK":"6.5","CHN":"250","CM":"25.1","IN":"9.9"}, {"US M":"8","EU":"41","UK":"7","CHN":"255","CM":"25.5","IN":"10"}, {"US M":"8.5","EU":"42","UK":"7.5","CHN":"260","CM":"25.9","IN":"10.2"}, {"US M":"9","EU":"42.5","UK":"8","CHN":"265","CM":"26.3","IN":"10.4"}, {"US M":"9.5","EU":"43","UK":"8.5","CHN":"270","CM":"26.8","IN":"10.5"}, {"US M":"10","EU":"44","UK":"9","CHN":"270","CM":"27.2","IN":"10.7"}, {"US M":"10.5","EU":"44.5","UK":"9.5","CHN":"275","CM":"27.6","IN":"10.8"}, {"US M":"11","EU":"45","UK":"10","CHN":"280","CM":"28.0","IN":"11"}, {"US M":"11.5","EU":"45.5","UK":"10.5","CHN":"285","CM":"28.4","IN":"11.2"}, {"US M":"12","EU":"46","UK":"11","CHN":"290","CM":"28.9","IN":"11.3"}, {"US M":"12.5","EU":"47","UK":"11.5","CHN":"295","CM":"29.3","IN":"11.5"}, {"US M":"13","EU":"47.5","UK":"12","CHN":"300","CM":"29.7","IN":"11.7"}, {"US M":"13.5","EU":"48","UK":"12.5","CHN":"305","CM":"29.9","IN":"11.8"}, {"US M":"14","EU":"48.5","UK":"13","CHN":"310","CM":"30.5","IN":"12"}, {"US M":"15","EU":"49.5","UK":"14","CHN":"315","CM":"31.4","IN":"12.3"}, {"US M":"16","EU":"50.5","UK":"15","CHN":"325","CM":"32.3","IN":"12.7"}, {"US M":"17","EU":"51.5","UK":"16","CHN":"335","CM":"33.5","IN":"13.2"}
          ]
        },
        {
          "label": "ANTA Women's Shoes",
          "systems": ["US W", "EU", "CHN", "CM", "IN"],
          "rows": [
            {"US W":"5","EU":"35.5","CHN":"220","CM":"22.1","IN":"8.7"}, {"US W":"5.5","EU":"36","CHN":"225","CM":"22.6","IN":"8.9"}, {"US W":"6","EU":"36.5","CHN":"230","CM":"23.0","IN":"9.0"}, {"US W":"6.5","EU":"37.5","CHN":"235","CM":"23.4","IN":"9.2"}, {"US W":"7","EU":"38","CHN":"235","CM":"23.8","IN":"9.4"}, {"US W":"7.5","EU":"38.5","CHN":"240","CM":"24.2","IN":"9.5"}, {"US W":"8","EU":"39","CHN":"245","CM":"24.7","IN":"9.7"}, {"US W":"8.5","EU":"40","CHN":"250","CM":"25.1","IN":"9.9"}, {"US W":"9.5","EU":"41","CHN":"255","CM":"25.5","IN":"10.2"}, {"US W":"10","EU":"42","CHN":"260","CM":"26.0","IN":"10.4"}
          ]
        }
      ]
    },
    "anta-kids": {
      "label": "ANTA Kids Size Guide",
      "systems": ["US Kids", "UK", "EU", "CHN", "CM", "IN"],
      "rows": [
        {"US Kids":"1.5Y","UK":"1","EU":"33","CHN":"205","CM":"20.5","IN":"8.1"},
        {"US Kids":"2.5Y","UK":"2","EU":"34","CHN":"215","CM":"21.5","IN":"8.5"},
        {"US Kids":"3Y","UK":"2.5","EU":"35","CHN":"220","CM":"22.0","IN":"8.7"},
        {"US Kids":"4Y","UK":"3.5","EU":"36","CHN":"230","CM":"23.0","IN":"9.0"},
        {"US Kids":"5Y","UK":"4.5","EU":"37","CHN":"235","CM":"23.5","IN":"9.2"},
        {"US Kids":"5.5Y","UK":"5","EU":"38","CHN":"240","CM":"24.0","IN":"9.4"},
        {"US Kids":"6.5Y","UK":"6","EU":"39","CHN":"245","CM":"24.5","IN":"9.6"},
        {"US Kids":"7Y","UK":"6.5","EU":"40","CHN":"250","CM":"25.0","IN":"9.8"},
        {"US Kids":"8Y","UK":"7","EU":"41","CHN":"255","CM":"25.5","IN":"10.0"}
      ]
    },
    "peak": {
      "label": "PEAK Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "1.5",
          "US W": "3",
          "UK": "W1",
          "EU": "33",
          "CM": "21.5"
        },
        {
          "US M": "2.5",
          "US W": "4",
          "UK": "W1.5",
          "EU": "34",
          "CM": "22"
        },
        {
          "US M": "3",
          "US W": "4.5",
          "UK": "W2",
          "EU": "35",
          "CM": "22.5"
        },
        {
          "US M": "4",
          "US W": "5.5",
          "UK": "W3",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "UK": "W3.5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "US W": "7",
          "UK": "W4.5/M5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "W5.5/M6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "W6/M6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "9",
          "US W": "10",
          "UK": "7.5",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "UK": "8.5",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "UK": "9",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "UK": "10",
          "EU": "45",
          "CM": "27.5"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "UK": "11",
          "EU": "46",
          "CM": "28"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "UK": "12",
          "EU": "47",
          "CM": "28.5"
        },
        {
          "US M": "14",
          "US W": "15.5",
          "UK": "13",
          "EU": "48",
          "CM": "29"
        },
        {
          "US M": "15",
          "US W": "16.5",
          "UK": "14",
          "EU": "49",
          "CM": "29.5"
        },
        {
          "US M": "16",
          "US W": "17.5",
          "UK": "15",
          "EU": "50",
          "CM": "30"
        }
      ]
    },
    "peak-kids": {
      "label": "PEAK Kids Size Guide",
      "systems": [
        "US Kids",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US Kids": "8C",
          "EU": "25",
          "CM": "15.5"
        },
        {
          "US Kids": "9C",
          "EU": "26",
          "CM": "16"
        },
        {
          "US Kids": "10C",
          "EU": "27",
          "CM": "16.5"
        },
        {
          "US Kids": "11C",
          "EU": "28",
          "CM": "17.5"
        },
        {
          "US Kids": "12C",
          "EU": "29",
          "CM": "18"
        },
        {
          "US Kids": "13C",
          "EU": "31",
          "CM": "19"
        },
        {
          "US Kids": "1Y",
          "EU": "32",
          "CM": "19.5"
        },
        {
          "US Kids": "1.5Y",
          "EU": "33",
          "CM": "20.5"
        },
        {
          "US Kids": "2.5Y",
          "EU": "34",
          "CM": "21.5"
        },
        {
          "US Kids": "3Y",
          "EU": "35",
          "CM": "22"
        },
        {
          "US Kids": "4Y",
          "EU": "36",
          "CM": "22"
        },
        {
          "US Kids": "5Y",
          "EU": "37",
          "CM": "23"
        },
        {
          "US Kids": "5.5Y",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US Kids": "6.5Y",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US Kids": "7Y",
          "EU": "40",
          "CM": "25"
        }
      ]
    },
    "xtep": {
      "label": "Xtep Jeremy Lin Basketball Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "6.5",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7.5",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "8",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8.5",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "9",
          "EU": "45",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9.5",
          "EU": "46",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "10",
          "EU": "47",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10.5",
          "EU": "48",
          "CM": "29"
        }
      ]
    },
    "bmai": {
      "label": "BMAI Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3.5",
          "UK": "3",
          "EU": "35",
          "CM": "21.5"
        },
        {
          "US M": "4",
          "UK": "3.5",
          "EU": "36",
          "CM": "22"
        },
        {
          "US M": "4.5",
          "UK": "4",
          "EU": "36.5",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "UK": "4.5",
          "EU": "37",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "UK": "5",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "UK": "5.5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "7",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7.5",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "8",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8.5",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "9",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9.5",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "10",
          "EU": "45",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10.5",
          "EU": "46",
          "CM": "29"
        }
      ]
    },
    "qiaodan": {
      "label": "QIAODAN Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3",
          "US W": "4.5",
          "UK": "2",
          "EU": "35",
          "CM": "21.5"
        },
        {
          "US M": "3.5",
          "US W": "5",
          "UK": "2.5",
          "EU": "35.5",
          "CM": "22"
        },
        {
          "US M": "4",
          "US W": "5.5",
          "UK": "3",
          "EU": "36",
          "CM": "22.5"
        },
        {
          "US M": "4.5",
          "US W": "6",
          "UK": "3.5",
          "EU": "37",
          "CM": "23"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "UK": "4",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "UK": "4.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "UK": "5",
          "EU": "38.5",
          "CM": "24.5"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "5.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "US W": "9",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "UK": "8.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "UK": "10",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "UK": "11",
          "EU": "46",
          "CM": "29.5"
        },
        {
          "US M": "12.5",
          "US W": "14",
          "UK": "11.5",
          "EU": "47",
          "CM": "30"
        },
        {
          "US M": "13.5",
          "US W": "15",
          "UK": "12.5",
          "EU": "48",
          "CM": "30.5"
        }
      ]
    },
    "under-armour": {
      "label": "Under Armour Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3.5",
          "US W": "5",
          "UK": "3",
          "EU": "35.5",
          "CM": "22.5"
        },
        {
          "US M": "4",
          "US W": "5.5",
          "UK": "3.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "4.5",
          "US W": "6",
          "UK": "4",
          "EU": "36.5",
          "CM": "23.5"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "UK": "4.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "UK": "5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "5.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "US W": "9",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "UK": "8.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "UK": "10",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "US W": "13",
          "UK": "10.5",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "UK": "11",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "US W": "14",
          "UK": "11.5",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "UK": "12",
          "EU": "47.5",
          "CM": "31"
        },
        {
          "US M": "13.5",
          "US W": "15",
          "UK": "12.5",
          "EU": "48",
          "CM": "31.5"
        },
        {
          "US M": "14",
          "US W": "15.5",
          "UK": "13",
          "EU": "48.5",
          "CM": "32"
        },
        {
          "US M": "14.5",
          "US W": "16",
          "UK": "13.5",
          "EU": "49",
          "CM": "32.5"
        },
        {
          "US M": "15",
          "US W": "16.5",
          "UK": "14",
          "EU": "49.5",
          "CM": "33"
        },
        {
          "US M": "15.5",
          "US W": "17",
          "UK": "14.5",
          "EU": "50",
          "CM": "33.5"
        },
        {
          "US M": "16",
          "US W": "17.5",
          "UK": "15",
          "EU": "50.5",
          "CM": "34"
        }
      ]
    },
    "erke": {
      "label": "ERKE Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3.5",
          "US W": "4.5",
          "UK": "3",
          "EU": "33",
          "CM": "21.5"
        },
        {
          "US M": "4",
          "US W": "5",
          "UK": "3.5",
          "EU": "34",
          "CM": "22"
        },
        {
          "US M": "4.5",
          "US W": "5.5",
          "UK": "4",
          "EU": "35",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "US W": "6",
          "UK": "4.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "US W": "6.5",
          "UK": "5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "US W": "7",
          "UK": "5.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "7.5",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "US W": "8.5",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "US W": "9",
          "UK": "7.5",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "US W": "9.5",
          "UK": "8",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "US W": "10",
          "UK": "8.5",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "US W": "10.5",
          "UK": "9",
          "EU": "45",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "US W": "11",
          "UK": "9.5",
          "EU": "46",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "US W": "11.5",
          "UK": "10",
          "EU": "47",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "US W": "12",
          "UK": "10.5",
          "EU": "48",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "US W": "12.5",
          "UK": "11",
          "EU": "49",
          "CM": "29.5"
        }
      ]
    },
    "tansher": {
      "label": "TANSHER Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "5",
          "UK": "4",
          "EU": "35",
          "CM": "22.5"
        },
        {
          "US M": "5.5",
          "UK": "4.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "6",
          "UK": "5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US M": "6.5",
          "UK": "5.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "45",
          "CM": "27.5"
        }
      ]
    },
    "rigorer-1": {
      "label": "Rigorer Size Guide 1",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "4",
          "US W": "5.5",
          "UK": "3.5",
          "EU": "35",
          "CM": "22"
        },
        {
          "US M": "4.5",
          "US W": "6",
          "UK": "4",
          "EU": "36",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "UK": "4.5",
          "EU": "37",
          "CM": "23"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "5.5",
          "EU": "39",
          "CM": "25"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "40",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "UK": "8",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "UK": "8.5",
          "EU": "43",
          "CM": "27"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "UK": "9",
          "EU": "44",
          "CM": "27.5"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "UK": "10",
          "EU": "45",
          "CM": "28.5"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "UK": "11",
          "EU": "46",
          "CM": "29"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "UK": "12",
          "EU": "47",
          "CM": "30"
        },
        {
          "US M": "14",
          "US W": "15.5",
          "UK": "13",
          "EU": "48",
          "CM": "30.5"
        },
        {
          "US M": "14.5",
          "US W": "16",
          "UK": "13.5",
          "EU": "49",
          "CM": "31"
        },
        {
          "US M": "15",
          "US W": "16.5",
          "UK": "14",
          "EU": "50",
          "CM": "32"
        },
        {
          "US M": "16",
          "US W": "17.5",
          "UK": "15",
          "EU": "51",
          "CM": "32.5"
        },
        {
          "US M": "17",
          "US W": "18.5",
          "UK": "16",
          "EU": "52",
          "CM": "33"
        }
      ]
    },
    "rigorer-2": {
      "label": "Rigorer Size Guide 2",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "5.5",
          "EU": "39",
          "CM": "24"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "39.5",
          "CM": "24.5"
        },
        {
          "US M": "7.5",
          "US W": "9",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "UK": "7.5",
          "EU": "41.5",
          "CM": "26"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "UK": "8",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "UK": "8.5",
          "EU": "42.5",
          "CM": "26.5"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "UK": "9",
          "EU": "43",
          "CM": "27"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "UK": "9.5",
          "EU": "44",
          "CM": "27.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "UK": "10",
          "EU": "44.5",
          "CM": "28"
        },
        {
          "US M": "11.5",
          "US W": "13",
          "UK": "10.5",
          "EU": "45",
          "CM": "28.5"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "UK": "11",
          "EU": "46",
          "CM": "29"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "UK": "12",
          "EU": "47.5",
          "CM": "30.5"
        },
        {
          "US M": "14",
          "US W": "15.5",
          "UK": "13",
          "EU": "48.5",
          "CM": "31.5"
        },
        {
          "US M": "15",
          "US W": "16.5",
          "UK": "14",
          "EU": "49.5",
          "CM": "32"
        }
      ]
    },
    "rigorer-kids": {
      "label": "Rigorer Kids Size Guide",
      "systems": [
        "US Kids",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US Kids": "12.5C",
          "EU": "30",
          "CM": "18.5"
        },
        {
          "US Kids": "0.5",
          "EU": "31",
          "CM": "19.5"
        },
        {
          "US Kids": "1.5",
          "EU": "32",
          "CM": "20"
        },
        {
          "US Kids": "2",
          "EU": "33",
          "CM": "20.5"
        },
        {
          "US Kids": "3",
          "EU": "34",
          "CM": "21.5"
        },
        {
          "US Kids": "3.5",
          "EU": "35",
          "CM": "22"
        },
        {
          "US Kids": "4.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US Kids": "5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US Kids": "6",
          "EU": "38",
          "CM": "24"
        },
        {
          "US Kids": "6.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US Kids": "7.5",
          "EU": "40",
          "CM": "25"
        }
      ]
    },
    "rigorer-slides": {
      "label": "Rigorer Slides Size Guide",
      "systems": [
        "US M",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "9",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "9.5",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "10",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "11",
          "EU": "45",
          "CM": "27.5"
        },
        {
          "US M": "12",
          "EU": "46",
          "CM": "28"
        },
        {
          "US M": "13",
          "EU": "47",
          "CM": "28.5"
        },
        {
          "US M": "14",
          "EU": "48",
          "CM": "29"
        },
        {
          "US M": "15",
          "EU": "49",
          "CM": "29.5"
        },
        {
          "US M": "16",
          "EU": "50",
          "CM": "30"
        },
        {
          "US M": "17",
          "EU": "51",
          "CM": "30.5"
        }
      ]
    },
    "361-1": {
      "label": "361° Size Guide 1",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3.5",
          "US W": "5",
          "UK": "2.5",
          "EU": "35",
          "CM": "22.5"
        },
        {
          "US M": "4.5",
          "US W": "6",
          "UK": "3.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "UK": "4.5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "5.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "UK": "7.5",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "UK": "8",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "UK": "9",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "UK": "9.5",
          "EU": "45",
          "CM": "27.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "UK": "10",
          "EU": "46",
          "CM": "28"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "UK": "11",
          "EU": "47",
          "CM": "28.5"
        },
        {
          "US M": "12.5",
          "US W": "14",
          "UK": "11.5",
          "EU": "48",
          "CM": "29"
        }
      ]
    },
    "361-2": {
      "label": "361° Size Guide 2",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3",
          "US W": "4.5",
          "UK": "2.5",
          "EU": "35",
          "CM": "22"
        },
        {
          "US M": "3.5",
          "US W": "5",
          "UK": "3",
          "EU": "35.5",
          "CM": "22.5"
        },
        {
          "US M": "4",
          "US W": "5.5",
          "UK": "3.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "4.5",
          "US W": "6",
          "UK": "4",
          "EU": "36.5",
          "CM": "23.5"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "UK": "5.5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "US W": "9",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "UK": "8.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "UK": "10",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "US W": "13",
          "UK": "10.5",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "UK": "11",
          "EU": "46",
          "CM": "29.5"
        },
        {
          "US M": "12.5",
          "US W": "14",
          "UK": "11.5",
          "EU": "47",
          "CM": "30"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "UK": "12",
          "EU": "47.5",
          "CM": "30.5"
        },
        {
          "US M": "13.5",
          "US W": "15",
          "UK": "12.5",
          "EU": "48",
          "CM": "31"
        },
        {
          "US M": "14",
          "US W": "15.5",
          "UK": "13",
          "EU": "48.5",
          "CM": "31.5"
        },
        {
          "US M": "14.5",
          "US W": "16",
          "UK": "13.5",
          "EU": "49",
          "CM": "32"
        },
        {
          "US M": "15",
          "US W": "16.5",
          "UK": "14",
          "EU": "49.5",
          "CM": "32.5"
        },
        {
          "US M": "15.5",
          "US W": "17",
          "UK": "14.5",
          "EU": "50",
          "CM": "33"
        }
      ]
    },
    "361-joker": {
      "label": "361 Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM",
        "IN"
      ],
      "rows": [
        { "US M": "4", "US W": "5.5", "UK": "3.5", "EU": "36", "CM": "23.0", "IN": "9.0\"" },
        { "US M": "5", "US W": "6.5", "UK": "4", "EU": "37.5", "CM": "23.5", "IN": "9.2\"" },
        { "US M": "5.5", "US W": "7", "UK": "4.5", "EU": "38", "CM": "24.0", "IN": "9.4\"" },
        { "US M": "6", "US W": "7.5", "UK": "5", "EU": "38.5", "CM": "24.0", "IN": "9.4\"" },
        { "US M": "6.5", "US W": "8", "UK": "5.5", "EU": "39", "CM": "24.5", "IN": "9.6\"" },
        { "US M": "7", "US W": "8.5", "UK": "6", "EU": "40", "CM": "25.0", "IN": "9.8\"" },
        { "US M": "7.5", "US W": "9", "UK": "6.5", "EU": "40.5", "CM": "25.5", "IN": "10.0\"" },
        { "US M": "8", "US W": "9.5", "UK": "7", "EU": "41", "CM": "26.0", "IN": "10.2\"" },
        { "US M": "8.5", "US W": "10", "UK": "7.5", "EU": "42", "CM": "26.5", "IN": "10.4\"" },
        { "US M": "9", "US W": "10.5", "UK": "8", "EU": "42.5", "CM": "27.0", "IN": "10.6\"" },
        { "US M": "9.5", "US W": "11", "UK": "8.5", "EU": "43", "CM": "27.5", "IN": "10.8\"" },
        { "US M": "10", "US W": "11.5", "UK": "9", "EU": "44", "CM": "28.0", "IN": "11.0\"" },
        { "US M": "10.5", "US W": "12", "UK": "9.5", "EU": "44.5", "CM": "28.5", "IN": "11.2\"" },
        { "US M": "11", "US W": "12.5", "UK": "10", "EU": "45", "CM": "29.0", "IN": "11.4\"" },
        { "US M": "11.5", "US W": "13", "UK": "10.5", "EU": "45.5", "CM": "29.5", "IN": "11.6\"" },
        { "US M": "12", "US W": "13.5", "UK": "11", "EU": "46", "CM": "29.5", "IN": "11.6\"" },
        { "US M": "12.5", "US W": "14", "UK": "11.5", "EU": "47", "CM": "30.0", "IN": "11.8\"" },
        { "US M": "13", "US W": "14.5", "UK": "12", "EU": "47.5", "CM": "30.5", "IN": "12.0\"" },
        { "US M": "14", "US W": "15.5", "UK": "13", "EU": "48.5", "CM": "31.5", "IN": "12.4\"" },
        { "US M": "15", "US W": "16.5", "UK": "14", "EU": "49.5", "CM": "32.5", "IN": "12.8\"" }
      ]
    },
    "361-slides": {
      "label": "361° Slides Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "6.5",
          "UK": "5.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "26"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "27"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "45",
          "CM": "27.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "46",
          "CM": "28"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "47",
          "CM": "28.5"
        }
      ]
    },
    "eqlz": {
      "label": "EQLZ Size Guide",
      "systems": [
        "US M",
        "US W",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "4.5",
          "US W": "6",
          "EU": "36.5",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "EU": "37.5",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "US W": "9",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "US W": "13",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "US W": "14",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "EU": "47.5",
          "CM": "31"
        },
        {
          "US M": "14",
          "US W": "15.5",
          "EU": "48.5",
          "CM": "32"
        },
        {
          "US M": "15",
          "US W": "16.5",
          "EU": "49.5",
          "CM": "33"
        }
      ]
    },
    "eqlz-slides": {
      "label": "EQLZ Slides Size Guide",
      "systems": [
        "US M",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3-3.5",
          "EU": "34-35",
          "CM": "20.5-21.5"
        },
        {
          "US M": "4-4.5",
          "EU": "36-37",
          "CM": "22-23"
        },
        {
          "US M": "5.5-6.5",
          "EU": "38-39",
          "CM": "23.5-24.5"
        },
        {
          "US M": "7-8",
          "EU": "40-41",
          "CM": "25-26"
        },
        {
          "US M": "8.5-9",
          "EU": "42-42.5",
          "CM": "26.5-27"
        },
        {
          "US M": "9.5-10",
          "EU": "43-44",
          "CM": "27.5-28"
        },
        {
          "US M": "10.5-11",
          "EU": "44.5-45",
          "CM": "28.5-29"
        },
        {
          "US M": "11.5-12",
          "EU": "45.5-46",
          "CM": "29.5-30"
        },
        {
          "US M": "12.5-13",
          "EU": "47-47.5",
          "CM": "30.5-31"
        }
      ]
    },
    "spo": {
      "label": "Serious Player Only Size Guide",
      "systems": [
        "US M",
        "US W",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "4",
          "US W": "5.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "US W": "13",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "EU": "47.5",
          "CM": "31"
        },
        {
          "US M": "14",
          "US W": "15.5",
          "EU": "48.5",
          "CM": "32"
        },
        {
          "US M": "15",
          "US W": "16.5",
          "EU": "49.5",
          "CM": "33"
        },
        {
          "US M": "16",
          "US W": "17.5",
          "EU": "50.5",
          "CM": "34"
        }
      ]
    },
    "dowin": {
      "label": "Dowin Size Guide",
      "systems": [
        "US M",
        "US W",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "4.5",
          "US W": "6",
          "EU": "35",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "EU": "41.5",
          "CM": "26"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "EU": "43",
          "CM": "27"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "EU": "44",
          "CM": "27.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "EU": "45",
          "CM": "28"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "EU": "46",
          "CM": "28.5"
        }
      ]
    },
    "reebok": {
      "label": "Reebok Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {"US M":"3.5","US W":"5","UK":"2.5","EU":"34","CM":"22.5"},
        {"US M":"4","US W":"5.5","UK":"3","EU":"34.5","CM":"23"},
        {"US M":"4.5","US W":"6","UK":"3.5","EU":"35","CM":"23.3"},
        {"US M":"5","US W":"6.5","UK":"4","EU":"36","CM":"23.5"},
        {"US M":"5.5","US W":"7","UK":"4.5","EU":"36.5","CM":"23.6"},
        {"US M":"6","US W":"7.5","UK":"5","EU":"37.5","CM":"24"},
        {"US M":"6.5","US W":"8","UK":"5.5","EU":"38.5","CM":"24.5"},
        {"US M":"7","US W":"8.5","UK":"6","EU":"39","CM":"25"},
        {"US M":"7.5","US W":"9","UK":"6.5","EU":"40","CM":"25.5"},
        {"US M":"8","US W":"9.5","UK":"7","EU":"40.5","CM":"26"},
        {"US M":"8.5","US W":"10","UK":"7.5","EU":"41","CM":"26.5"},
        {"US M":"9","US W":"10.5","UK":"8","EU":"42","CM":"27"},
        {"US M":"9.5","US W":"11","UK":"8.5","EU":"42.5","CM":"27.5"},
        {"US M":"10","US W":"11.5","UK":"9","EU":"43","CM":"28"},
        {"US M":"10.5","US W":"12","UK":"9.5","EU":"44","CM":"28.5"},
        {"US M":"11","US W":"12.5","UK":"10","EU":"44.5","CM":"29"},
        {"US M":"11.5","US W":"13","UK":"10.5","EU":"45","CM":"29.5"},
        {"US M":"12","US W":"13.5","UK":"11","EU":"45.5","CM":"30"},
        {"US M":"12.5","US W":"14","UK":"11.5","EU":"46","CM":"30.5"},
        {"US M":"13","US W":"14.5","UK":"12","EU":"47","CM":"31"},
        {"US M":"13.5","US W":"15","UK":"12.5","EU":"48","CM":"31.5"},
        {"US M":"14","US W":"15.5","UK":"13","EU":"48.5","CM":"32"}
      ]
    },
    "nike": {
      "label": "Nike Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3.5",
          "US W": "5",
          "UK": "3",
          "EU": "35.5",
          "CM": "22.5"
        },
        {
          "US M": "4",
          "US W": "5.5",
          "UK": "3.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "4.5",
          "US W": "6",
          "UK": "4",
          "EU": "36.5",
          "CM": "23.5"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "UK": "5.5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "US W": "9",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "UK": "8.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "UK": "10",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "US W": "13",
          "UK": "10.5",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "UK": "11",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "US W": "14",
          "UK": "11.5",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "UK": "12",
          "EU": "47.5",
          "CM": "31"
        },
        {
          "US M": "13.5",
          "US W": "15",
          "UK": "12.5",
          "EU": "48",
          "CM": "31.5"
        },
        {
          "US M": "14",
          "US W": "15.5",
          "UK": "13",
          "EU": "48.5",
          "CM": "32"
        },
        {
          "US M": "15",
          "US W": "16.5",
          "UK": "14",
          "EU": "49.5",
          "CM": "33"
        },
        {
          "US M": "16",
          "US W": "17.5",
          "UK": "15",
          "EU": "50.5",
          "CM": "34"
        },
        {
          "US M": "17",
          "US W": "18.5",
          "UK": "16",
          "EU": "51.5",
          "CM": "35"
        }
      ]
    },
    "xtep-running": {
      "label": "Xtep Running Shoes Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "4.5",
          "UK": "3.5",
          "EU": "37",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "UK": "4",
          "EU": "37.5",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "UK": "4.5",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "UK": "5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "UK": "5.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "UK": "10.5",
          "EU": "46",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46.5",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "UK": "12",
          "EU": "48",
          "CM": "31"
        }
      ]
    },
    "volanti-rocket": {
      "label": "Volanti Rocket Air Cushion Spike Shoes Size Guide",
      "systems": [
        "US M",
        "US W",
        "EU",
        "CHN",
        "CM"
      ],
      "rows": [
        {"US M":"4","US W":"5.5","EU":"36","CHN":"225","CM":"22.5"},
        {"US M":"4.5","US W":"6","EU":"37","CHN":"235","CM":"23.5"},
        {"US M":"5.5","US W":"7","EU":"38","CHN":"240","CM":"24"},
        {"US M":"6.5","US W":"8","EU":"39","CHN":"245","CM":"24.5"},
        {"US M":"7","US W":"8.5","EU":"40","CHN":"250","CM":"25"},
        {"US M":"8","US W":"9.5","EU":"41","CHN":"260","CM":"26"},
        {"US M":"8.5","US W":"10","EU":"42","CHN":"265","CM":"26.5"},
        {"US M":"9.5","US W":"11","EU":"43","CHN":"275","CM":"27.5"},
        {"US M":"10","US W":"11.5","EU":"44","CHN":"280","CM":"28"},
        {"US M":"11","US W":"12.5","EU":"45","CHN":"290","CM":"29"}
      ]
    },
    "volanti": {
      "label": "Volanti Size Guide",
      "systems": [
        "US M",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "4",
          "EU": "36",
          "CM": "22.5"
        },
        {
          "US M": "4.5",
          "EU": "36.5",
          "CM": "23"
        },
        {
          "US M": "5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US M": "5.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "EU": "48",
          "CM": "31.5"
        },
        {
          "US M": "13.5",
          "EU": "49",
          "CM": "32"
        },
        {
          "US M": "14.5",
          "EU": "50",
          "CM": "32.5"
        }
      ]
    },
    "adidas-yeezy": {
      "label": "Adidas Yeezy Size Guide",
      "systems": ["US M", "UK", "EU", "CM"],
      "rows": [
        {"US M":"4","UK":"3.5","EU":"36","CM":"22.1"},
        {"US M":"4.5","UK":"4","EU":"36 2/3","CM":"22.5"},
        {"US M":"5","UK":"4.5","EU":"37 1/3","CM":"22.9"},
        {"US M":"5.5","UK":"5","EU":"38","CM":"23.3"},
        {"US M":"6","UK":"5.5","EU":"38 2/3","CM":"23.8"},
        {"US M":"6.5","UK":"6","EU":"39 1/3","CM":"24.2"},
        {"US M":"7","UK":"6.5","EU":"40","CM":"24.6"},
        {"US M":"7.5","UK":"7","EU":"40 2/3","CM":"25.0"},
        {"US M":"8","UK":"7.5","EU":"41 1/3","CM":"25.5"},
        {"US M":"8.5","UK":"8","EU":"42","CM":"25.9"},
        {"US M":"9","UK":"8.5","EU":"42 2/3","CM":"26.3"},
        {"US M":"9.5","UK":"9","EU":"43 1/3","CM":"26.7"},
        {"US M":"10","UK":"9.5","EU":"44","CM":"27.1"},
        {"US M":"10.5","UK":"10","EU":"44 2/3","CM":"27.6"},
        {"US M":"11","UK":"10.5","EU":"45 1/3","CM":"28.0"},
        {"US M":"11.5","UK":"11","EU":"46","CM":"28.4"},
        {"US M":"12","UK":"11.5","EU":"46 2/3","CM":"28.8"},
        {"US M":"12.5","UK":"12","EU":"47 1/3","CM":"29.3"},
        {"US M":"13","UK":"12.5","EU":"48","CM":"29.7"},
        {"US M":"13.5","UK":"13","EU":"48 2/3","CM":"30.1"},
        {"US M":"14","UK":"13.5","EU":"49 1/3","CM":"30.5"},
        {"US M":"14.5","UK":"14","EU":"50","CM":"31.0"},
        {"US M":"15","UK":"14.5","EU":"50 2/3","CM":"31.4"},
        {"US M":"16","UK":"15","EU":"51 1/3","CM":"31.8"},
        {"US M":"17","UK":"16","EU":"52 2/3","CM":"32.6"},
        {"US M":"18","UK":"17","EU":"53 1/3","CM":"33.5"},
        {"US M":"19","UK":"18","EU":"54 2/3","CM":"34.3"},
        {"US M":"20","UK":"19","EU":"55 2/3","CM":"35.2"}
      ]
    },
    "adidas": {
      "label": "Adidas Size Guide",
      "systems": ["US M", "US W", "UK", "EU", "CM"],
      "rows": [
        {"US M":"4","US W":"5","UK":"3.5","EU":"36","CM":"22.1"},
        {"US M":"4.5","US W":"5.5","UK":"4","EU":"36 2/3","CM":"22.5"},
        {"US M":"5","US W":"6","UK":"4.5","EU":"37 1/3","CM":"22.9"},
        {"US M":"5.5","US W":"6.5","UK":"5","EU":"38","CM":"23.3"},
        {"US M":"6","US W":"7","UK":"5.5","EU":"38 2/3","CM":"23.8"},
        {"US M":"6.5","US W":"7.5","UK":"6","EU":"39 1/3","CM":"24.2"},
        {"US M":"7","US W":"8","UK":"6.5","EU":"40","CM":"24.6"},
        {"US M":"7.5","US W":"8.5","UK":"7","EU":"40 2/3","CM":"25.0"},
        {"US M":"8","US W":"9","UK":"7.5","EU":"41 1/3","CM":"25.5"},
        {"US M":"8.5","US W":"9.5","UK":"8","EU":"42","CM":"25.9"},
        {"US M":"9","US W":"10","UK":"8.5","EU":"42 2/3","CM":"26.3"},
        {"US M":"9.5","US W":"10.5","UK":"9","EU":"43 1/3","CM":"26.7"},
        {"US M":"10","US W":"11","UK":"9.5","EU":"44","CM":"27.1"},
        {"US M":"10.5","US W":"11.5","UK":"10","EU":"44 2/3","CM":"27.6"},
        {"US M":"11","US W":"12","UK":"10.5","EU":"45 1/3","CM":"28.0"},
        {"US M":"11.5","US W":"12.5","UK":"11","EU":"46","CM":"28.4"},
        {"US M":"12","US W":"13","UK":"11.5","EU":"46 2/3","CM":"28.8"},
        {"US M":"12.5","US W":"13.5","UK":"12","EU":"47 1/3","CM":"29.3"},
        {"US M":"13","US W":"14","UK":"12.5","EU":"48","CM":"29.7"},
        {"US M":"13.5","US W":"14.5","UK":"13","EU":"48 2/3","CM":"30.1"},
        {"US M":"14","US W":"15","UK":"13.5","EU":"49 1/3","CM":"30.5"},
        {"US M":"14.5","US W":"15.5","UK":"14","EU":"50","CM":"31.0"},
        {"US M":"15","US W":"—","UK":"14.5","EU":"50 2/3","CM":"31.4"},
        {"US M":"16","US W":"—","UK":"15","EU":"51 1/3","CM":"31.8"},
        {"US M":"17","US W":"—","UK":"16","EU":"52 2/3","CM":"32.6"},
        {"US M":"18","US W":"—","UK":"17","EU":"53 1/3","CM":"33.5"},
        {"US M":"19","US W":"—","UK":"18","EU":"54 2/3","CM":"34.3"},
        {"US M":"20","US W":"—","UK":"19","EU":"55 2/3","CM":"35.2"}
      ]
    },
    "asics": {
      "label": "ASICS Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "4",
          "UK": "3",
          "EU": "36",
          "CM": "22.5"
        },
        {
          "US M": "4.5",
          "UK": "3.5",
          "EU": "37",
          "CM": "23"
        },
        {
          "US M": "5",
          "UK": "4",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US M": "5.5",
          "UK": "4.5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6",
          "UK": "5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "6.5",
          "UK": "5.5",
          "EU": "39.5",
          "CM": "25"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "40",
          "CM": "25.25"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41.5",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "43.5",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28.25"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "45",
          "CM": "28.5"
        },
        {
          "US M": "11.5",
          "UK": "10.5",
          "EU": "46",
          "CM": "29"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46.5",
          "CM": "29.5"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "47",
          "CM": "30"
        },
        {
          "US M": "13",
          "UK": "12",
          "EU": "48",
          "CM": "30.5"
        },
        {
          "US M": "14",
          "UK": "13",
          "EU": "49",
          "CM": "31"
        }
      ]
    },
    "converse": {
      "label": "Converse Size Guide",
      "systems": [
        "US M",
        "US W",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3",
          "US W": "4.5",
          "UK": "2.5",
          "EU": "35",
          "CM": "21"
        },
        {
          "US M": "3.5",
          "US W": "5",
          "UK": "3",
          "EU": "35.5",
          "CM": "21.5"
        },
        {
          "US M": "4",
          "US W": "5.5",
          "UK": "3.5",
          "EU": "36",
          "CM": "22"
        },
        {
          "US M": "4.5",
          "US W": "6",
          "UK": "4",
          "EU": "37",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "US W": "6.5",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "US W": "7",
          "UK": "5",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "US W": "7.5",
          "UK": "5.5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "US W": "8",
          "UK": "5.5",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "US W": "8.5",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "US W": "9",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "US W": "9.5",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "US W": "10",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "US W": "10.5",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "US W": "11",
          "UK": "8.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "US W": "11.5",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "US W": "12",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "US W": "12.5",
          "UK": "10",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "US W": "13",
          "UK": "10.5",
          "EU": "46",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "US W": "13.5",
          "UK": "11",
          "EU": "46.5",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "US W": "14",
          "UK": "11.5",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "US W": "14.5",
          "UK": "12",
          "EU": "47.5",
          "CM": "31"
        },
        {
          "US M": "13.5",
          "US W": "15",
          "UK": "12.5",
          "EU": "48",
          "CM": "31.5"
        },
        {
          "US M": "14",
          "US W": "15.5",
          "UK": "13",
          "EU": "49",
          "CM": "32"
        },
        {
          "US M": "14.5",
          "US W": "16",
          "UK": "13.5",
          "EU": "49.5",
          "CM": "32.5"
        },
        {
          "US M": "15",
          "US W": "16.5",
          "UK": "14",
          "EU": "50",
          "CM": "33"
        },
        {
          "US M": "16",
          "US W": "17.5",
          "UK": "15",
          "EU": "51.5",
          "CM": "34"
        },
        {
          "US M": "17",
          "US W": "18.5",
          "UK": "16",
          "EU": "53",
          "CM": "35"
        },
        {
          "US M": "18",
          "US W": "19.5",
          "UK": "17",
          "EU": "54.5",
          "CM": "36"
        }
      ]
    },
    "mizuno": {
      "label": "Mizuno Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "4",
          "UK": "3",
          "EU": "35",
          "CM": "22"
        },
        {
          "US M": "4.5",
          "UK": "3.5",
          "EU": "36",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "UK": "4",
          "EU": "36.5",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "UK": "4.5",
          "EU": "37",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "UK": "5.5",
          "EU": "38.5",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "39",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "40",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "40.5",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "41",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "42.5",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "43",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "44.5",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "UK": "10.5",
          "EU": "45",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "46.5",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "UK": "12",
          "EU": "47",
          "CM": "31"
        },
        {
          "US M": "14",
          "UK": "13",
          "EU": "48.5",
          "CM": "32"
        },
        {
          "US M": "15",
          "UK": "14",
          "EU": "50",
          "CM": "33"
        },
        {
          "US M": "16",
          "UK": "15",
          "EU": "51",
          "CM": "34"
        }
      ]
    },
    "new-balance": {
      "label": "New Balance Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3",
          "UK": "2.5",
          "EU": "35",
          "CM": "21"
        },
        {
          "US M": "3.5",
          "UK": "3",
          "EU": "35.5",
          "CM": "21.5"
        },
        {
          "US M": "4",
          "UK": "3.5",
          "EU": "36",
          "CM": "22"
        },
        {
          "US M": "4.5",
          "UK": "4",
          "EU": "37",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "UK": "5",
          "EU": "38",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "UK": "5.5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "UK": "6",
          "EU": "39.5",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6.5",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "7",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7.5",
          "EU": "41.5",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "8",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8.5",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "9",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9.5",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "10",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10.5",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "UK": "11",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "UK": "11.5",
          "EU": "46.5",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "UK": "12",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "UK": "12.5",
          "EU": "47.5",
          "CM": "31"
        },
        {
          "US M": "14",
          "UK": "13.5",
          "EU": "49",
          "CM": "32"
        },
        {
          "US M": "15",
          "UK": "14.5",
          "EU": "50",
          "CM": "33"
        },
        {
          "US M": "16",
          "UK": "15.5",
          "EU": "51",
          "CM": "34"
        }
      ]
    },
    "puma": {
      "label": "PUMA Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3.5",
          "UK": "2.5",
          "EU": "35",
          "CM": "21.5"
        },
        {
          "US M": "4",
          "UK": "3",
          "EU": "35.5",
          "CM": "22"
        },
        {
          "US M": "4.5",
          "UK": "3.5",
          "EU": "36",
          "CM": "22.5"
        },
        {
          "US M": "5",
          "UK": "4",
          "EU": "37",
          "CM": "23"
        },
        {
          "US M": "5.5",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US M": "6",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "UK": "5.5",
          "EU": "38.5",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "39",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "40",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "40.5",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "41",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "42.5",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "43",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "44.5",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "UK": "10.5",
          "EU": "45",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "46.5",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "UK": "12",
          "EU": "47",
          "CM": "31"
        },
        {
          "US M": "13.5",
          "UK": "12.5",
          "EU": "47.5",
          "CM": "31.5"
        },
        {
          "US M": "14",
          "UK": "13",
          "EU": "48",
          "CM": "32"
        },
        {
          "US M": "14.5",
          "UK": "13.5",
          "EU": "48.5",
          "CM": "32.5"
        }
      ]
    },
    "ugg": {
      "label": "UGG Size Guide",
      "systems": [
        "US M",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "5",
          "EU": "36",
          "CM": "22"
        },
        {
          "US M": "6",
          "EU": "37",
          "CM": "23"
        },
        {
          "US M": "7",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "8",
          "EU": "39",
          "CM": "25"
        },
        {
          "US M": "9",
          "EU": "40",
          "CM": "26"
        },
        {
          "US M": "10",
          "EU": "41",
          "CM": "27"
        },
        {
          "US M": "11",
          "EU": "42",
          "CM": "28"
        }
      ]
    },
    "kailas": {
      "label": "KAILAS Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "displayLabels": {
        "US M": "US",
        "UK": "UK",
        "EU": "EU",
        "CM": "CM"
      },
      "rows": [
        {
          "US M": "4",
          "UK": "3.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "4.5",
          "UK": "4",
          "EU": "36.5",
          "CM": "23.3"
        },
        {
          "US M": "5",
          "UK": "4.5",
          "EU": "37",
          "CM": "23.7"
        },
        {
          "US M": "5.5",
          "UK": "5",
          "EU": "37.5",
          "CM": "24"
        },
        {
          "US M": "6",
          "UK": "5.5",
          "EU": "38",
          "CM": "24.4"
        },
        {
          "US M": "6.5",
          "UK": "6",
          "EU": "39",
          "CM": "25"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "40",
          "CM": "25.2"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "41",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41.5",
          "CM": "25.8"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "25.8"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42.5",
          "CM": "26.2"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "43",
          "CM": "26.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "26.8"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "27.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "45",
          "CM": "28.2"
        },
        {
          "US M": "11.5",
          "UK": "10.5",
          "EU": "46",
          "CM": "28.8"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46.5",
          "CM": "29.2"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "47",
          "CM": "29.5"
        }
      ]
    },
    "jordan": {
      "label": "Jordan Size Guide",
      "systems": [
        "US M",
        "UK",
        "EU",
        "CM"
      ],
      "rows": [
        {
          "US M": "3",
          "UK": "2.5",
          "EU": "35",
          "CM": "22"
        },
        {
          "US M": "3.5",
          "UK": "3",
          "EU": "35.5",
          "CM": "22.5"
        },
        {
          "US M": "4",
          "UK": "3.5",
          "EU": "36",
          "CM": "23"
        },
        {
          "US M": "4.5",
          "UK": "4",
          "EU": "36.5",
          "CM": "23.5"
        },
        {
          "US M": "5",
          "UK": "4.5",
          "EU": "37.5",
          "CM": "23.5"
        },
        {
          "US M": "5.5",
          "UK": "5",
          "EU": "38",
          "CM": "24"
        },
        {
          "US M": "6",
          "UK": "5.5",
          "EU": "38.5",
          "CM": "24"
        },
        {
          "US M": "6.5",
          "UK": "6",
          "EU": "39",
          "CM": "24.5"
        },
        {
          "US M": "7",
          "UK": "6",
          "EU": "40",
          "CM": "25"
        },
        {
          "US M": "7.5",
          "UK": "6.5",
          "EU": "40.5",
          "CM": "25.5"
        },
        {
          "US M": "8",
          "UK": "7",
          "EU": "41",
          "CM": "26"
        },
        {
          "US M": "8.5",
          "UK": "7.5",
          "EU": "42",
          "CM": "26.5"
        },
        {
          "US M": "9",
          "UK": "8",
          "EU": "42.5",
          "CM": "27"
        },
        {
          "US M": "9.5",
          "UK": "8.5",
          "EU": "43",
          "CM": "27.5"
        },
        {
          "US M": "10",
          "UK": "9",
          "EU": "44",
          "CM": "28"
        },
        {
          "US M": "10.5",
          "UK": "9.5",
          "EU": "44.5",
          "CM": "28.5"
        },
        {
          "US M": "11",
          "UK": "10",
          "EU": "45",
          "CM": "29"
        },
        {
          "US M": "11.5",
          "UK": "10.5",
          "EU": "45.5",
          "CM": "29.5"
        },
        {
          "US M": "12",
          "UK": "11",
          "EU": "46",
          "CM": "30"
        },
        {
          "US M": "12.5",
          "UK": "11.5",
          "EU": "47",
          "CM": "30.5"
        },
        {
          "US M": "13",
          "UK": "12",
          "EU": "47.5",
          "CM": "31"
        },
        {
          "US M": "13.5",
          "UK": "12.5",
          "EU": "48",
          "CM": "31.5"
        },
        {
          "US M": "14",
          "UK": "13",
          "EU": "48.5",
          "CM": "32"
        },
        {
          "US M": "14.5",
          "UK": "13.5",
          "EU": "49",
          "CM": "32.5"
        },
        {
          "US M": "15",
          "UK": "14",
          "EU": "49.5",
          "CM": "33"
        },
        {
          "US M": "15.5",
          "UK": "14.5",
          "EU": "50",
          "CM": "33.5"
        },
        {
          "US M": "16",
          "UK": "15",
          "EU": "50.5",
          "CM": "34"
        },
        {
          "US M": "16.5",
          "UK": "15.5",
          "EU": "51",
          "CM": "34.5"
        },
        {
          "US M": "17",
          "UK": "16",
          "EU": "51.5",
          "CM": "35"
        },
        {
          "US M": "17.5",
          "UK": "16.5",
          "EU": "52",
          "CM": "35.5"
        },
        {
          "US M": "18",
          "UK": "17",
          "EU": "52.5",
          "CM": "36"
        }
      ]
    },
    "way-of-wade-pants": {
      "label": "Way of Wade Men's Trousers Size Guide",
      "apparel": true,
      "systems": ["Size"],
      "rows": [
        {"Size":"S"}, {"Size":"M"}, {"Size":"L"}, {"Size":"XL"}, {"Size":"2XL"}, {"Size":"3XL"}
      ],
      "tables": [
        {
          "label": "Men's Trousers — Manual measurement (inches)",
          "systems": ["Size", "Waist (in)", "Length (in)", "Hip (in)", "Thigh (in)"],
          "rows": [
            {"Size":"S","Waist (in)":"26","Length (in)":"37.4","Hip (in)":"41","Thigh (in)":"24.8"},
            {"Size":"M","Waist (in)":"27.6","Length (in)":"38.6","Hip (in)":"42.5","Thigh (in)":"25.8"},
            {"Size":"L","Waist (in)":"29","Length (in)":"39.8","Hip (in)":"44","Thigh (in)":"26.8"},
            {"Size":"XL","Waist (in)":"30.7","Length (in)":"41","Hip (in)":"45.7","Thigh (in)":"27.8"},
            {"Size":"XXL","Waist (in)":"32.3","Length (in)":"42.2","Hip (in)":"47.3","Thigh (in)":"28.8"},
            {"Size":"3XL","Waist (in)":"33.9","Length (in)":"43.3","Hip (in)":"48.8","Thigh (in)":"29.8"}
          ]
        }
      ]
    },
    "lining-clothing-pants": {
      "label": "Li-Ning Clothing & Pants Size Guide",
      "apparel": true,
      "systems": ["Size"],
      "rows": [
        {"Size":"S"}, {"Size":"M"}, {"Size":"L"}, {"Size":"XL"}, {"Size":"2XL"}, {"Size":"3XL"}
      ],
      "tables": [
        {
          "label": "Li-Ning Men's Tops — General Asian sizing",
          "systems": ["Asian size", "UK size", "Chest (in/cm)", "Length (in/cm)", "Shoulder (in/cm)", "Sleeve (in/cm)"],
          "rows": [
            {"Asian size":"S","UK size":"XS","Chest (in/cm)":"34.5–36 / 88–92","Length (in/cm)":"25.6–26.8 / 65–68","Shoulder (in/cm)":"16.5–17.3 / 42–44","Sleeve (in/cm)":"23.2–24.0 / 59–61"},
            {"Asian size":"M","UK size":"S","Chest (in/cm)":"36–38 / 92–96","Length (in/cm)":"26.8–28.0 / 68–71","Shoulder (in/cm)":"17.3–18.1 / 44–46","Sleeve (in/cm)":"24.0–24.8 / 61–63"},
            {"Asian size":"L","UK size":"M","Chest (in/cm)":"38–39.5 / 96–100","Length (in/cm)":"28.0–29.1 / 71–74","Shoulder (in/cm)":"18.1–18.9 / 46–48","Sleeve (in/cm)":"24.8–25.6 / 63–65"},
            {"Asian size":"XL","UK size":"L","Chest (in/cm)":"39.5–41 / 100–104","Length (in/cm)":"29.1–30.3 / 74–77","Shoulder (in/cm)":"18.9–19.7 / 48–50","Sleeve (in/cm)":"25.6–26.4 / 65–67"},
            {"Asian size":"2XL","UK size":"XL","Chest (in/cm)":"41–42.5 / 104–108","Length (in/cm)":"30.3–31.5 / 77–80","Shoulder (in/cm)":"19.7–20.5 / 50–52","Sleeve (in/cm)":"26.4–27.2 / 67–69"},
            {"Asian size":"3XL","UK size":"2XL","Chest (in/cm)":"42.5–44 / 108–112","Length (in/cm)":"31.5–32.7 / 80–83","Shoulder (in/cm)":"20.5–21.3 / 52–54","Sleeve (in/cm)":"27.2–28.0 / 69–71"}
          ]
        },
        {
          "label": "Li-Ning Men's Bottoms — General Asian sizing",
          "systems": ["Asian size", "UK waist", "Waist (in/cm)", "Hip (in/cm)", "Length (in/cm)"],
          "rows": [
            {"Asian size":"S","UK waist":"28–30","Waist (in/cm)":"28–30 / 71–76","Hip (in/cm)":"35.0–37.4 / 89–95","Length (in/cm)":"39.4–40.6 / 100–103"},
            {"Asian size":"M","UK waist":"30–32","Waist (in/cm)":"30–32 / 76–81","Hip (in/cm)":"37.4–39.8 / 95–101","Length (in/cm)":"40.2–41.3 / 102–105"},
            {"Asian size":"L","UK waist":"32–34","Waist (in/cm)":"32–34 / 81–86","Hip (in/cm)":"39.8–42.1 / 101–107","Length (in/cm)":"40.9–42.1 / 104–107"},
            {"Asian size":"XL","UK waist":"34–36","Waist (in/cm)":"34–36 / 86–91","Hip (in/cm)":"42.1–44.5 / 107–113","Length (in/cm)":"41.7–42.9 / 106–109"},
            {"Asian size":"2XL","UK waist":"36–38","Waist (in/cm)":"36–38 / 91–97","Hip (in/cm)":"44.5–46.9 / 113–119","Length (in/cm)":"42.5–43.7 / 108–111"},
            {"Asian size":"3XL","UK waist":"38–40","Waist (in/cm)":"38–40 / 97–102","Hip (in/cm)":"46.9–49.2 / 119–125","Length (in/cm)":"43.3–44.5 / 110–113"}
          ]
        }
      ]
    },
    "rigorer-pants": {
      "label": "Rigorer Pants Size Guide",
      "apparel": true,
      "systems": ["Size"],
      "rows": [
        {"Size":"XS"}, {"Size":"S"}, {"Size":"M"}, {"Size":"L"}, {"Size":"XL"}, {"Size":"2XL"}, {"Size":"3XL"}, {"Size":"4XL"}, {"Size":"5XL"}
      ],
      "tables": [
        {
          "label": "Rigorer Men's Training Pants",
          "systems": ["Size", "Pants length (in)", "Waist (in)", "Hip (in)", "Recommended weight (lb)", "Recommended height"],
          "rows": [
            {"Size":"XS","Pants length (in)":"37.2","Waist (in)":"28.0","Hip (in)":"42.5","Recommended weight (lb)":"99–132","Recommended height":"5'5\"–5'7\""},
            {"Size":"S","Pants length (in)":"38.2","Waist (in)":"29.1","Hip (in)":"44.1","Recommended weight (lb)":"121–143","Recommended height":"5'7\"–5'9\""},
            {"Size":"M","Pants length (in)":"39.2","Waist (in)":"30.3","Hip (in)":"45.7","Recommended weight (lb)":"132–154","Recommended height":"5'9\"–5'11\""},
            {"Size":"L","Pants length (in)":"40.2","Waist (in)":"31.5","Hip (in)":"47.2","Recommended weight (lb)":"143–165","Recommended height":"5'11\"–6'1\""},
            {"Size":"XL","Pants length (in)":"41.1","Waist (in)":"32.7","Hip (in)":"48.8","Recommended weight (lb)":"154–187","Recommended height":"6'1\"–6'3\""},
            {"Size":"2XL","Pants length (in)":"42.1","Waist (in)":"33.9","Hip (in)":"50.4","Recommended weight (lb)":"176–198","Recommended height":"6'3\"–6'5\""},
            {"Size":"3XL","Pants length (in)":"43.1","Waist (in)":"35.0","Hip (in)":"52.0","Recommended weight (lb)":"187–209","Recommended height":"6'5\"–6'7\""},
            {"Size":"4XL","Pants length (in)":"44.1","Waist (in)":"36.2","Hip (in)":"53.5","Recommended weight (lb)":"198–231","Recommended height":"6'7\"–6'9\""},
            {"Size":"5XL","Pants length (in)":"45.1","Waist (in)":"37.4","Hip (in)":"55.1","Recommended weight (lb)":"209–254","Recommended height":"6'9\"–6'11\""}
          ]
        }
      ]
    },
    "rigorer-clothing": {
      "label": "Rigorer Clothing Size Guide",
      "apparel": true,
      "systems": ["Size"],
      "rows": [
        {"Size":"XS"}, {"Size":"S"}, {"Size":"M"}, {"Size":"L"}, {"Size":"XL"}, {"Size":"2XL"}, {"Size":"3XL"}
      ],
      "tables": [
        {
          "label": "Rigorer Compression Tops",
          "systems": ["Size", "Height (in/cm)", "Length (in/cm)", "Chest (in/cm)", "Hem (in/cm)", "Waist (in/cm)"],
          "rows": [
            {"Size":"XS","Height (in/cm)":"5'3\" / 160","Length (in/cm)":"22.4 / 57","Chest (in/cm)":"29.1 / 74","Hem (in/cm)":"27.6 / 70","Waist (in/cm)":"26.0 / 66"},
            {"Size":"S","Height (in/cm)":"5'5\" / 165","Length (in/cm)":"23.2 / 59","Chest (in/cm)":"30.3 / 77","Hem (in/cm)":"28.7 / 73","Waist (in/cm)":"27.2 / 69"},
            {"Size":"M","Height (in/cm)":"5'7\" / 170","Length (in/cm)":"24.0 / 61","Chest (in/cm)":"31.5 / 80","Hem (in/cm)":"29.9 / 76","Waist (in/cm)":"28.3 / 72"},
            {"Size":"L","Height (in/cm)":"5'9\" / 175","Length (in/cm)":"24.8 / 63","Chest (in/cm)":"32.7 / 83","Hem (in/cm)":"31.1 / 79","Waist (in/cm)":"29.5 / 75"},
            {"Size":"XL","Height (in/cm)":"5'11\" / 180","Length (in/cm)":"25.6 / 65","Chest (in/cm)":"33.9 / 86","Hem (in/cm)":"32.3 / 82","Waist (in/cm)":"30.7 / 78"},
            {"Size":"2XL","Height (in/cm)":"6'1\" / 185","Length (in/cm)":"26.4 / 67","Chest (in/cm)":"35.0 / 89","Hem (in/cm)":"33.5 / 85","Waist (in/cm)":"31.9 / 81"},
            {"Size":"3XL","Height (in/cm)":"6'3\" / 190","Length (in/cm)":"27.2 / 69","Chest (in/cm)":"36.2 / 92","Hem (in/cm)":"34.6 / 88","Waist (in/cm)":"33.1 / 84"}
          ]
        },
        {
          "label": "Rigorer Basketball Shorts",
          "systems": ["Size", "Short length (in/cm)", "Hip (in/cm)", "Recommended height (in/cm)"],
          "rows": [
            {"Size":"S","Short length (in/cm)":"16.9 / 43","Hip (in/cm)":"41.7 / 106","Recommended height (in/cm)":"5'7\" / 170"},
            {"Size":"M","Short length (in/cm)":"17.7 / 45","Hip (in/cm)":"43.3 / 110","Recommended height (in/cm)":"5'9\" / 175"},
            {"Size":"L","Short length (in/cm)":"18.5 / 47","Hip (in/cm)":"44.9 / 114","Recommended height (in/cm)":"5'11\" / 180"},
            {"Size":"XL","Short length (in/cm)":"19.3 / 49","Hip (in/cm)":"46.5 / 118","Recommended height (in/cm)":"6'1\" / 185"},
            {"Size":"2XL","Short length (in/cm)":"20.1 / 51","Hip (in/cm)":"48.0 / 122","Recommended height (in/cm)":"6'3\" / 190"}
          ]
        }
      ]
    },
    "anta-clothing": {
      "label": "ANTA Clothing Size Guide",
      "apparel": true,
      "systems": ["Size"],
      "rows": [
        {"Size":"2XS"}, {"Size":"XS"}, {"Size":"S"}, {"Size":"M"}, {"Size":"L"}, {"Size":"XL"}, {"Size":"2XL"}, {"Size":"3XL"}, {"Size":"4XL"}
      ],
      "tables": [
        {
          "label": "ANTA Men's Tops",
          "systems": ["Size", "Chest (in/cm)", "Waist (in/cm)", "Hip (in/cm)", "Height (in/cm)"],
          "rows": [
            {"Size":"2XS","Chest (in/cm)":"28.1–31.5 / 72–80","Waist (in/cm)":"22.5–25.5 / 57–65","Hip (in/cm)":"28.5–31.5 / 72–80","Height (in/cm)":"<5'7\" / <170"},
            {"Size":"XS","Chest (in/cm)":"31.5–35 / 80–88","Waist (in/cm)":"25.5–29 / 65–73","Hip (in/cm)":"31.5–35 / 80–88","Height (in/cm)":"5'7\"–6'0\" / 170–183"},
            {"Size":"S","Chest (in/cm)":"35–37.5 / 88–96","Waist (in/cm)":"29–32 / 73–81","Hip (in/cm)":"35–37.5 / 88–96","Height (in/cm)":"5'7\"–6'0\" / 170–183"},
            {"Size":"M","Chest (in/cm)":"37.5–41 / 96–104","Waist (in/cm)":"32–35 / 81–89","Hip (in/cm)":"37.5–41 / 96–104","Height (in/cm)":"5'7\"–6'0\" / 170–183"},
            {"Size":"L","Chest (in/cm)":"41–44 / 104–112","Waist (in/cm)":"35–38 / 89–97","Hip (in/cm)":"41–44 / 104–112","Height (in/cm)":"5'7\"–6'0\" / 170–183"},
            {"Size":"XL","Chest (in/cm)":"44–48.5 / 112–124","Waist (in/cm)":"38–43 / 97–109","Hip (in/cm)":"44–47 / 112–120","Height (in/cm)":"5'7\"–6'0\" / 170–183"},
            {"Size":"2XL","Chest (in/cm)":"48.5–53.5 / 124–136","Waist (in/cm)":"43–47.5 / 109–121","Hip (in/cm)":"47–50.5 / 120–128","Height (in/cm)":"5'9\"–6'2\" / 175–188"},
            {"Size":"3XL","Chest (in/cm)":"53.5–58 / 136–148","Waist (in/cm)":"47.5–52.5 / 121–133","Hip (in/cm)":"50.5–53.5 / 128–136","Height (in/cm)":"5'9\"–6'2\" / 175–188"},
            {"Size":"4XL","Chest (in/cm)":"58–63 / 148–160","Waist (in/cm)":"52.5–57 / 133–145","Hip (in/cm)":"53.5–58.5 / 136–148","Height (in/cm)":"5'9\"–6'2\" / 175–188"}
          ]
        },
        {
          "label": "ANTA Men's Bottoms",
          "systems": ["Size", "Hip (in/cm)", "Waist (in/cm)", "Height (in/cm)"],
          "rows": [
            {"Size":"2XS","Hip (in/cm)":"28.5–31.5 / 72–80","Waist (in/cm)":"22.5–25.5 / 57–65","Height (in/cm)":"<5'7\" / <170"},
            {"Size":"XS","Hip (in/cm)":"31.5–35 / 80–88","Waist (in/cm)":"25.5–29 / 65–73","Height (in/cm)":"5'7\"–6'0\" / 170–183"},
            {"Size":"S","Hip (in/cm)":"35–37.5 / 88–96","Waist (in/cm)":"29–32 / 73–81","Height (in/cm)":"5'7\"–6'0\" / 170–183"},
            {"Size":"M","Hip (in/cm)":"37.5–41 / 96–104","Waist (in/cm)":"32–35 / 81–89","Height (in/cm)":"5'7\"–6'0\" / 170–183"},
            {"Size":"L","Hip (in/cm)":"41–44 / 104–112","Waist (in/cm)":"35–38 / 89–97","Height (in/cm)":"5'7\"–6'0\" / 170–183"},
            {"Size":"XL","Hip (in/cm)":"44–47 / 112–120","Waist (in/cm)":"38–43 / 97–109","Height (in/cm)":"5'7\"–6'0\" / 170–183"},
            {"Size":"2XL","Hip (in/cm)":"47–50.5 / 120–128","Waist (in/cm)":"43–47.5 / 109–121","Height (in/cm)":"5'9\"–6'2\" / 175–188"},
            {"Size":"3XL","Hip (in/cm)":"50.5–53.5 / 128–136","Waist (in/cm)":"47.5–52.5 / 121–133","Height (in/cm)":"5'9\"–6'2\" / 175–188"},
            {"Size":"4XL","Hip (in/cm)":"53.5–58.5 / 136–148","Waist (in/cm)":"52.5–57 / 133–145","Height (in/cm)":"5'9\"–6'2\" / 175–188"}
          ]
        },
        {
          "label": "ANTA Women's Tops",
          "systems": ["Size", "Chest (in/cm)", "Waist (in/cm)", "Hip (in/cm)"],
          "rows": [
            {"Size":"2XS","Chest (in/cm)":"27.5–29.5 / 70–76","Waist (in/cm)":"21.25–23.5 / 54–60","Hip (in/cm)":"30.5–33 / 78–84"},
            {"Size":"XS","Chest (in/cm)":"29.5–32.5 / 76–83","Waist (in/cm)":"23.5–26 / 60–67","Hip (in/cm)":"33–35.5 / 84–91"},
            {"Size":"S","Chest (in/cm)":"32.5–35.5 / 83–90","Waist (in/cm)":"26–29 / 67–74","Hip (in/cm)":"35.5–38.5 / 91–98"},
            {"Size":"M","Chest (in/cm)":"35.5–38 / 90–97","Waist (in/cm)":"29–31.5 / 74–81","Hip (in/cm)":"38.5–41 / 98–105"},
            {"Size":"L","Chest (in/cm)":"38–41 / 97–104","Waist (in/cm)":"31.5–34.5 / 81–88","Hip (in/cm)":"41–44 / 105–112"},
            {"Size":"XL","Chest (in/cm)":"41–44.5 / 104–114","Waist (in/cm)":"34.5–38.5 / 88–98","Hip (in/cm)":"44–47 / 112–120"},
            {"Size":"2XL","Chest (in/cm)":"44.5–48.5 / 114–124","Waist (in/cm)":"38.5–42.5 / 98–108","Hip (in/cm)":"47–50 / 120–128"}
          ]
        }
      ]
    }
  },
  "templateMap": {
    "sneaker-mystery-box": "sneaker-mystery-box",
    "size-chart-sneaker-mystery-box": "sneaker-mystery-box",
    "lining-size-chart-c-p": "lining-clothing-pants",
    "rigorer-clothing": "rigorer-clothing",
    "anta-clothing": "anta-clothing",
    "size-chart-lining-2": "lining",
    "size-chart-lining-kids": "lining-kids",
    "size-chart-anta": "anta",
    "anta-women": "anta",
    "size-chart-anta-kids": "anta-kids",
    "product-size-chart-peak": "peak",
    "peak-women": "peak",
    "size-chart-x-tep": "xtep",
    "bmai": "bmai",
    "qiaodan-2": "qiaodan",
    "qiaodan-women": "qiaodan",
    "under-amour": "under-armour",
    "erke": "erke",
    "tansher": "tansher",
    "rigorer-2": "rigorer-1",
    "rigorer-ar2": "rigorer-2",
    "rigorer-girl": "rigorer-1",
    "rigorer-kids": "rigorer-kids",
    "rigorer-slides": "rigorer-slides",
    "size-chart-361-361": "361-joker",
    "size-chart-361-2": "361-joker",
    "size-chart-361-dvd": "361-joker",
    "size-chart-361-slides": "361-joker",
    "eqlz-2": "eqlz",
    "eqlz-slides": "eqlz-slides",
    "spo-size-chart": "spo",
    "adidas-yeezy": "adidas-yeezy",
    "size-chart-adidas": "adidas",
    "size-chart-asics": "asics",
    "size-chart-converse": "converse",
    "size-chart-mizuno": "mizuno",
    "size-chart-new-balance": "new-balance",
    "size-chart-puma": "puma",
    "size-chart-reebok": "reebok",
    "size-chart-ugg": "ugg",
    "size-chart-volanti": "volanti",
    "volanti-size-chart-2": "volanti",
    "adidasxenoburst": "adidas",
    "size-chart-kailas": "kailas",
    "kailas": "kailas"
  },
  "vendorMap": {
    "361": "361-joker",
    "serious player only": "spo",
    "seriousplayeronly": "spo",
    "adidas yeezy": "adidas-yeezy",
    "yeezy": "adidas-yeezy",
    "jordan": "jordan",
    "air jordan": "jordan",
    "adidas": "adidas",
    "asics": "asics",
    "converse": "converse",
    "mizuno": "mizuno",
    "new balance": "new-balance",
    "newbalance": "new-balance",
    "puma": "puma",
    "reebok": "reebok",
    "ugg": "ugg",
    "volanti": "volanti",
    "li-ning": "lining",
    "lining": "lining",
    "anta": "anta",
    "peak": "peak",
    "xtep": "xtep",
    "x-tep": "xtep",
    "bmai": "bmai",
    "qiaodan": "qiaodan",
    "qiao dan": "qiaodan",
    "under armour": "under-armour",
    "erke": "erke",
    "tansher": "tansher",
    "rigorer": "rigorer-1",
    "361°": "361-joker",
    "eqlz": "eqlz",
    "spo": "spo",
    "dowin": "dowin",
    "kailas": "kailas",
    "凯乐石": "kailas"
  }
};
